import { render, staticRenderFns } from "./journalAdTabForm.vue?vue&type=template&id=e7fa9454&scoped=true&"
import script from "./journalAdTabForm.vue?vue&type=script&lang=js&"
export * from "./journalAdTabForm.vue?vue&type=script&lang=js&"
import style0 from "./journalAdTabForm.vue?vue&type=style&index=0&id=e7fa9454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fa9454",
  null
  
)

export default component.exports